import AddTestspielForm from '../components/AddTestspielFormV2'

export default function AddTestspielPage() {
  return <AddTestspielForm />
}
